"use client"

import { ColumnDef } from "@tanstack/react-table"
import { MoreHorizontal, ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import BeaconTypesRowActions from "./BeaconTpesRowActions"
import { format } from "date-fns"


export type BeaconsTypes = {
    id: string
    name: string
    description: string
    created_at: Date
    updated_at: Date
}
interface rowActionProps {
    onEdit: (data: any) => void;
    onDelete: (data: any) => void;
    roles: string[]
}
export const BeaconsTypesColumns = ({ onEdit, onDelete, roles }: rowActionProps): ColumnDef<BeaconsTypes>[] => {
    const beaconTypescolumns: ColumnDef<BeaconsTypes>[] = [
        {
            accessorKey: "id",
            header: "Id",
        },
        {
            accessorKey: "name",
            header: "Name",
        },
        {
            accessorKey: "description",
            header: "Description",
        },
        {
            accessorKey: "created_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Created At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.created_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: "updated_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Updated At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.updated_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>;
            },
        },

    ]

    if (roles.includes('beacon-types-edit') || roles.includes('beacon-types-delete')) {
        beaconTypescolumns.push({
            id: "actions",
            header: 'Actions',
            cell: ({ row }) => <BeaconTypesRowActions row={row} onEdit={onEdit} onDelete={onDelete} roles={roles} />,
        })
    }
    return beaconTypescolumns
};
